import type { WorkspacePageDetails } from "~/workspaces/state/workspace-page-details";
import { parseStreamedCompletionResponse } from "~/chat/utils/parse-streamed-completion-response";

type GetWorkspacePageDataParams = {
  pageId?: number;
  workspaceId: number;
};

async function* getWorkspacePageData(
  params: GetWorkspacePageDataParams,
): AsyncGenerator<WorkspacePageDetails> {
  const response = await fetch(`/api/pages/${params.pageId}/details`, {
    method: "GET",
  });

  if (!response.ok || !response.body) {
    const text = await response.text();
    throw new Error(
      `Failed to fetch page details. Status: ${response.status}. Response: ${text}`,
    );
  }

  yield* parseStreamedCompletionResponse(response);
}

export type { GetWorkspacePageDataParams };
export { getWorkspacePageData };
